import { useState } from "react";
import { useLocale, LANGUAGES } from "../../../context/locale";
import { ChevronDown } from "lucide-react";

const LanguageSelector = () => {
  const { language, setLanguage, availableLanguages } = useLocale();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        className="nav-link flex items-center gap-1"
        onClick={() => setOpen((o) => !o)}
        aria-label="Change language"
      >
        <span>{LANGUAGES[language]?.label || LANGUAGES.en.label}</span>
        <ChevronDown size={13} />
      </button>

      {open && (
        <div className="absolute top-full right-0 pt-3 w-40 z-50">
          <div className="card-ledger p-2 flex flex-col gap-1 shadow-lg text-left">
            {availableLanguages.map((code) => (
              <button
                key={code}
                type="button"
                onClick={() => {
                  setLanguage(code);
                  setOpen(false);
                }}
                className="px-3 py-2 rounded text-sm normal-case tracking-normal font-body text-left"
                style={{ fontWeight: code === language ? 600 : 400 }}
              >
                {LANGUAGES[code].label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
